import type { JavaScriptFunction } from '@unifyapps/defs/types/javascriptFunction';
import type { DependsOnType } from '@unifyapps/defs/types/page';
import { DependencyHelper } from '../../dependency/helpers/DependencyHelper';
import { PageFunctionHelper } from '../../helpers/PageFunctionHelper';
import { getIsEntitySuspendedDependencies } from '../hooks/useIsEntitySuspended';

export function buildPageFunctionImplicitDependencies({
  pageFunction,
}: {
  pageFunction: JavaScriptFunction;
}) {
  const deps: DependsOnType[][] = [];

  // Always add entity suspension dependencies for page functions
  const suspendedDeps = getIsEntitySuspendedDependencies(
    PageFunctionHelper.getDataSourceIds(pageFunction),
  );
  deps.push(suspendedDeps);

  return DependencyHelper.mergeDependsOn(deps);
}
